import { render, staticRenderFns } from "./UploadStep.vue?vue&type=template&id=09f46c32&scoped=true"
import script from "./UploadStep.vue?vue&type=script&lang=js"
export * from "./UploadStep.vue?vue&type=script&lang=js"
import style0 from "./UploadStep.vue?vue&type=style&index=0&id=09f46c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09f46c32",
  null
  
)

export default component.exports